import React, { useEffect, useState } from "react";
import {
  Card,
  Container,
  Grid,
  Typography,
  useTheme,
  Alert,
  CircularProgress,
  Backdrop,
  CardContent,
  Divider,
  Box,
  Stack,
  Accordion,
  AccordionDetails,
  AccordionSummary
} from "@mui/material";
import {
  ButtonComponent,
  DropdownComponent,
  InputComponent,
  TableComponent
} from "../../components/atoms";
import { CommonRepositoty, ShipmentRepository } from "../../repository";
import _ from "lodash";
import { getText, onGetCurrencySymble } from "../../utils/Credentials";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function CalculatorPage() {
  const [list, setList] = useState([]);
  const [isError, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [isResError, setResError] = useState(false);
  const [errorResMessage, setErrorResMessage] = useState("");

  const [location, setLocation] = useState(0);
  const [isLocationValid, setIsLocationValid] = useState(false);
  const [locationError, setLocationError] = useState(false);

  const [packageFrom, setPackageFrom] = useState("");
  const [weight, setWeight] = useState(0);
  const [isWeightValid, setIsWeightValid] = useState(false);
  const [weightError, setWeightError] = useState(false);
  const [weightVal, setWeightVal] = useState(0);
  const [genaratePrice, setGenaratePrice] = useState(false);
  const [resposeData, setResposeData] = useState(null);
  const [additionalCharges, setAdditionalCharges] = useState([]);


  const column = [
    {
      name: "weight",
      label: "Weight",
      options: {
        setCellProps: () => ({ style: { textAlign: "center" } }),
        customBodyRender: (value) => (
          <Typography variant="subtitle2" fontWeight={600}>
            {value}{_.get(resposeData, "unit", "lbs")} / {(value * 2.20462).toFixed(2)} lbs
          </Typography>
        )
      }
    },
    {
      name: "amount",
      label: "Shipping Cost",
      options: {
        setCellProps: () => ({ style: { textAlign: "center" } }),
        customBodyRender: (value) => (
          <Typography variant="subtitle2" fontWeight={600}>
            {onGetCurrencySymble(_.get(resposeData, "currency", "USD"))} {value}
          </Typography>
        )
      }
    },
    {
      name: "flag",
      label: "Shipping Carrier",
      options: {
        setCellProps: () => ({ style: { textAlign: "center" } }),
        customBodyRender: (value) => <img src={value} />
      }
    }
  ];

  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);

  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);

  useEffect(() => {
    onCallLocations();
  }, []);

  const onCallLocations = async () => {
    handleOpen();
    const data = await CommonRepositoty.onGetLocationList();
    if (data?.status_code === 1) {
      setList(_.get(data, "data", []).map(i => ({ ...i, name: i.short_name })));
      setError(false);
    } else {
      setError(true);
    }
    setErrorMessage(_.get(data, "message", ""));
    handleClose();
  };

  const onGetUpdate = async () => {
    setResError(false);
    if (isLocationValid && isWeightValid) {
      handleOpen();
      const response = await CommonRepositoty.onGetShippingCost({
        packageFrom,
        unit: "kg",
        weight
      });

      if (response?.status_code === 1) {
        const value = _.get(response, "data.rates[0]");
        setResposeData(value);

        const flag = _.get(value, "courier_logo", "");
        setData(_.map(_.get(value, "rates", []), i => ({ ...i, flag })));

        setGenaratePrice(true);
      } else {
        setResError(true);
        setErrorResMessage(_.get(response, "message", ""));
      }
      handleClose();
    } else {
      if (!isLocationValid) setLocationError(true);
      if (!isWeightValid) setWeightError(true);
    }
  };

  const onWeight = (e) => {
    const text = getText(e);
    const number = parseFloat(text).toFixed(3);
    setWeightVal(number);
    setIsWeightValid(number > 0);
    setWeightError(false);
    setWeight(text);
  };

  const onChangeLocation = (e) => {
    const text = getText(e);
    setLocation(text);
    setLocationError(false);
    setIsLocationValid(text > 0);
    const value = _.find(list, i => i.id == text);
    setPackageFrom(_.get(value, "name", ""));
  };

    useEffect(() => {
      onGetAdditionalChargesList();
    }, []);
  
    const onGetAdditionalChargesList = async () => {
      setResError(false);
      handleOpen();
      const response = await ShipmentRepository.getAdditionalShippingCost();
      if (response) {
        if (response?.status_code == 1) {
          setAdditionalCharges(_.get(response, "data", []));

        } else {
        }
        handleClose();
      }
  };

  return (
    <Container sx={{ mt: 5, mb: 5 }} maxWidth="xl">
      {isResError && <Alert severity="error">{errorResMessage}</Alert>}

      <Card variant="outlined" sx={{ p: 3, borderRadius: 2 }}>
        <CardContent>

          {/* INPUT SECTION WITH RIGHT SIDE CARD */}
          <Grid container spacing={3}>

            {/* LEFT INPUTS */}
            <Grid item xs={12} md={8}>
              <Grid container flexDirection="column" rowSpacing={2}>

                <Grid item sx={{ display: "flex", flexDirection: "column", rowGap: 1 }}>
                  <Typography variant="subtitle1" color={useTheme().palette.grey[500]}>
                    Where is your package from?
                  </Typography>
                  <DropdownComponent
                    isError={locationError}
                    error="Location is required"
                    onChange={onChangeLocation}
                    dropdownList={list}
                    label="Please Select Location"
                    disabled={false}
                  />
                </Grid>

                <Grid item sx={{ display: "flex", flexDirection: "column", rowGap: 1 }}>
                  <Typography variant="subtitle1" color={useTheme().palette.grey[500]}>
                    How much does the package weigh? Kilograms (Kg)
                  </Typography>
                  <InputComponent
                    isError={weightError}
                    error={weightVal == 0 ? "Weight is required" : "Weight is invalid"}
                    onChange={onWeight}
                    type="number"
                    label="Weight"
                  />
                </Grid>

                <Grid item>
                  <Typography variant="subtitle2" color={useTheme().palette.grey[500]}>
                   Fortunately, you do not have to worry about complex dimensional weight calculations. Presto Worldwide pricing system gives you guaranteed upfront pricing based only on the package's weight (excludes oversized* and palletized shipments).
                  <br/>*Oversized shipments are defined as linear dimensions (total Length + Width + Height) greater than 80 inches
                  </Typography>
                </Grid>

                <Grid item>
                  <ButtonComponent
                    onClick={onGetUpdate}
                    variant="contained"
                    name="Get Shipping Cost"
                  />
                </Grid>

                {isError && (
                  <Grid item>
                    <Alert severity="error">{errorMessage}</Alert>
                  </Grid>
                )}

              </Grid>
            </Grid>

            {/* RIGHT SIDE INFO CARD */}
            <Grid item xs={12} md={4}>
              <Card
                variant="outlined"
                sx={{
                  borderRadius: 2,
                  backgroundColor: "#faf7ff",
                  height: "100%"
                }}
              >
                <CardContent>
                  <Typography variant="subtitle1" fontWeight={600} color="#572682">
                    Additional Shipment Charges
                  </Typography>

                  <Typography variant="subtitle2" color="GrayText" mb={2}>
                    These charges are applied at the time of shipment creation. Any selected features below will be added to the total shipment cost.
                  </Typography>

                  <Stack spacing={1}>
                    {additionalCharges.length > 0 && (<>
                       {additionalCharges.map((item, index) => (
                    <Box display="flex" justifyContent="space-between">
                      <Typography variant="subtitle2">{item.title}</Typography>
                      <Typography variant="subtitle2" fontWeight={600}> {onGetCurrencySymble(
                    _.get(resposeData, "currency", "USD")
                  )}{" "} {item.cost}</Typography>
                    </Box>
                       ))}
                   </> )}

                  </Stack>
                </CardContent>
              </Card>
            </Grid>

          </Grid>

          {/* RESULT SECTION — UNCHANGED */}
       {genaratePrice && (
          <Box mt={2}>
            <Divider />
            <Stack mt={2} spacing={2}>
              
              <Box>
                <Typography
                  variant="h6"
                  fontFamily={"Source Sans Pro"}
                  color={"#572682"}
                  fontWeight={600}
                >
                  Estimated Shipping Costs
                </Typography>
                <Typography
                  variant="subtitle2"
                  fontFamily={"Source Sans Pro"}
                  color={"GrayText"}
                  fontWeight={500}
                >
                  Shipping cost does not reflect your additional option costs.
                </Typography>
              </Box>

              <Grid container justifyContent={"center"} spacing={1} alignItems={"center"}>
                
                <Grid item xl={3} lg={3} md={3} sm={3} xs={12}>
                  <Typography
                    variant="subtitle2"
                    fontFamily={"Source Sans Pro"}
                    fontWeight={600}
                    color={"GrayText"}
                  >
                    Weight
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    fontFamily={"Source Sans Pro"}
                    fontWeight={600}
                    color={"black"}
                  >
                    {`${_.get(resposeData, "weight", 0)}${_.get(resposeData, "unit", "Lbs")} / ${( (_.get(resposeData, "weight", 0)) * 2.20462 ).toFixed(2)} lbs`}
                  </Typography>
                </Grid>

                <Grid item xl={3} lg={3} md={3} sm={3} xs={12}>
                  <Typography
                    variant="subtitle2"
                    fontFamily={"Source Sans Pro"}
                    fontWeight={600}
                    color={"GrayText"}
                  >
                    Shipping Cost
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    fontFamily={"Source Sans Pro"}
                    fontWeight={600}
                    color={"black"}
                  >
                    {`${onGetCurrencySymble(_.get(resposeData, "currency", "USD"))} ${_.get(resposeData, "shippingCost", 0)}`}
                  </Typography>
                </Grid>

                <Grid item xl={3} lg={3} md={3} sm={3} xs={12}>
                  <Typography
                    variant="subtitle2"
                    fontFamily={"Source Sans Pro"}
                    fontWeight={600}
                    color={"GrayText"}
                  >
                    Transit Time
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    fontFamily={"Source Sans Pro"}
                    fontWeight={600}
                    color={"black"}
                  >
                    {_.get(resposeData, "transmitTime", "")}
                  </Typography>
                </Grid>

                <Grid item xl={3} lg={3} md={3} sm={3} xs={12}>
                  <Typography
                    variant="subtitle2"
                    fontFamily={"Source Sans Pro"}
                    fontWeight={600}
                    color={"GrayText"}
                  >
                    Shipping Carrier
                  </Typography>
                  <img src={_.get(resposeData, "courier_logo")} alt="Courier Logo" />
                </Grid>

              </Grid>

              <Accordion sx={{ boxShadow: "none" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Typography
                    variant="subtitle1"
                    color={"#572682"}
                    fontWeight={600}
                    fontFamily={"Source Sans Pro"}
                  >
                    View more options
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <TableComponent
                    columns={column}
                    selectableRows="none"
                    search={false}
                    data={data}
                  />
                </AccordionDetails>
              </Accordion>

            </Stack>
          </Box>
        )}


        </CardContent>
      </Card>

      <Backdrop open={open} sx={{ color: "#fff", zIndex: 9999 }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Container>
  );
}
